import styled from "styled-components"

import { minWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"
import Grid from "components/grid"

export const Container = styled.div`
  width: calc(100% - 5.4rem);
  margin: 4rem 2.7rem;

  ${minWidth.tablet`
    width: 100%;
    margin: 4rem auto;
  `}
`

export const Bio = styled.div`
  ${minWidth.tablet`
    padding: 0 4rem;
    display: flex;
  `}
`

export const Info = styled.div`
  width: 100%;
  padding-bottom: 6rem;
  flex: 1 1 0;

  ${minWidth.tablet`
    margin-left: 8.3333%;
    padding-top: 4rem;
    padding-right: 2rem;
    order: 1;
  `}

  ${minWidth.hamburgerLarge`
    margin: 0 8.3333%;
    padding-right: 0;
    padding-bottom: 2.5rem;
  `}
`

export const Title = styled.h1`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3.9rem;
  font-weight: 500;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.text.primary};

  ${minWidth.tablet`
    margin-bottom: 1rem;
    font-size: 4.4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 70%;
    margin-bottom: 1.5rem;
    font-size: 6.8rem;
  `}
`

export const Description = styled.div`
  margin: 2rem 0 3rem;

  ${minWidth.hamburgerLarge`
    margin: 3rem 0 4rem;
  `}

  p {
    margin: 0;
    font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 1.6rem;
    line-height: 1.625;
    color: ${({ theme }) => theme.colors.text.primary};
  }
`

export const SocialMediaTitle = styled.h2`
  margin-bottom: 3rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  text-align: center;
  color: #767676;

  ${minWidth.tablet`
    text-align: left;
  `}
`

export const SocialMediaIcons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  ${minWidth.tablet`
    justify-content: flex-start;
  `}
`

export const SocialMediaLink = styled.a`
  margin-right: 2.5rem;

  &:last-of-type {
    margin-right: 0;
  }
`

export const LogoWrapper = styled.div`
  max-width: 20rem;
  margin: 0 auto 4rem;
  display: flex;
  align-items: center;

  ${minWidth.tablet`
    width: 22rem;
    max-width: 100%;
    margin: 0;
    order: 2;
  `}

  ${minWidth.hamburgerLarge`
    width: 36rem;
  `}
`

export const Logo = styled(CloudinaryImage)`
  height: auto;

  img {
    position: relative;
    width: auto;
    height: auto;
    object-fit: contain;
    object-position: left center;
  }
`

export const Bottom = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const StyledGrid = styled(Grid)`
  ${minWidth.tablet`
    width: calc(100% - 32rem);
  `}

  h2 {
    margin-bottom: 4rem;
    border-bottom: 0;
    font-size: 3rem;
    font-weight: 500;
    text-align: center;

    ${minWidth.hamburgerLarge`
      margin-bottom: 6rem;
      font-size: 4.8rem;
    `}
  }
`

export const ConnectWrapper = styled.div`
  display: none;

  ${minWidth.tablet`
    width: 32rem;
    padding: 4rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `}
`

export const ConnectTitle = styled.h1`
  width: 100%;
  margin-bottom: 4rem;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3rem;
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ConnectFeed = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`
